class App {
  constructor() {
    this.preDefinedApps = {
      NETFLIX: "com.netflix.mediaclient",
      SPOTIFY: "com.spotify.tv.android",
      USB: "com.playmore.filemanager",
      MIRACAST: "com.droidlogic.miracast",
      YOUTUBE: "com.google.android.youtube.tv",
      BROWSER: "org.mozilla.tv.firefox"
    }
    this._mouseRequiredApps = [
      "com.digiturk.iq.mobil",
      "com.amazon.avod.thirdpartyclient",
      "com.netflix.mediaclient",
      "net.mbc.shahid",
      "com.osn.go",
      "com.watchit.vod",
      "com.mubi"
    ]
  }
  async _init() {
    if (playmore.device.getUsbDevices) {
      const usbDevices = JSON.parse(playmore.device.getUsbDevices())
      if (usbDevices.state && usbDevices.devices.find(device => device.productName.includes("ruwido"))) this._mouseRequiredApps = []
    }

    return true
  }

  async getList() {
    try {
      const res = JSON.parse(playmore.platform.getInstalledApps())
      if (!res) return res

      const applist = []
      res.forEach(app => applist.push({ key: app.packageName, value: app.name }))
      applist.push({ key: "com.droidlogic.miracast", value: "miracast" })
      applist.push({ key: "com.playmore.filemanager", value: "usb" })
      applist.push({ key: "com.android.tv.settings", value: "settings" })
      applist.push({ key: "com.droidlogic.tv.settings", value: "tvsettings" })

      const whitelist = applist.map(app => app.key)
      playmore.platform.whiteApps(whitelist.join())

      return applist
    } catch (err) {
      return _$.error(err)
    }
  }
  async launch(app_id) {
    if (!app_id) return false
    let promise = await _$.progress.create()

    const config_mouse_required_apps = __.device.config("mouse_required_apps.mouse_required_apps")
    if (config_mouse_required_apps === null || config_mouse_required_apps === "null") this._mouseRequiredApps = []

    const externalMouseRequiredApps = config_mouse_required_apps?.split(",")
    if (externalMouseRequiredApps && externalMouseRequiredApps.length)
      this._mouseRequiredApps = this._mouseRequiredApps.concat(externalMouseRequiredApps)

    if (this._mouseRequiredApps.includes(app_id) && !playmore.device.isMouseOpen()) {
      const container = document.getElementById("staticPopup")
      const res = await _$.loadImage("/assets/images/airmouse_required.jpg", false, true)
      if (res) {
        _$.nav.disable()
        let promiseMouse = await _$.progress.create()
        container.appendChild(res)
        _$.vue.$emit("toplevel", true)
        container.style.display = "inherit"
        container.style.zIndex = "99"
        _$.vue.$once("airMouseActive", () => {
          _$.nav.enable()
          container.innerHTML = ""
          container.style.display = "none"
          container.style.zIndex = "-1"
          promiseMouse.resolve()
          _$.sleep(1000).then(() => _$.vue.$emit("toplevel", false))
        })
        await promiseMouse.done
      }
    } else if (!this._mouseRequiredApps.includes(app_id) && playmore.device.isMouseOpen()) {
      const container = document.getElementById("staticPopup")
      const res = await _$.loadImage("/assets/images/airmouse_deactivate.jpg", false, true)
      if (res) {
        _$.nav.disable()
        let promiseMouse = await _$.progress.create()
        container.appendChild(res)
        _$.vue.$emit("toplevel", true)
        container.style.display = "inherit"
        container.style.zIndex = "99"
        _$.vue.$once("airMouseDeactive", () => {
          _$.nav.enable()
          container.innerHTML = ""
          container.style.display = "none"
          container.style.zIndex = "-1"
          promiseMouse.resolve()
          _$.sleep(1000).then(() => _$.vue.$emit("toplevel", false))
        })
        await promiseMouse.done
      }
    }

    await __.platform.unfocusing()
    _$.vue.$once("applicationUnfocused", () => promise.resolve())

    /* Library Code */
    let res = false
    if (app_id === "com.playmore.filemanager") res = playmore.platform.openFileManager()
    else res = playmore.platform.openApp(app_id)

    if (!res) promise.reject()

    /* Library Code */

    return promise.done
  }
  async close() {
    let promise = await _$.progress.create()

    _$.vue.$once("applicationFocusing", () => promise.resolve())

    playmore.platform.closeActiveApps()

    return promise.done
  }
}

export default App
